import "core-js/stable";

import "regenerator-runtime/runtime";

import * as Turbo from "@hotwired/turbo";

require("@rails/ujs").start();
import $ from "jquery";

// $(document).ready(() => {
//   $.rails.refreshCSRFTokens();
// });

/* STIMULUS */
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";
import { Autocomplete } from "stimulus-autocomplete";

const stimulus = Application.start();
stimulus.register("autocomplete", Autocomplete);

const context = require.context(
  "../../controllers/radio_airplay",
  true,
  /\.js$/,
);
//console.log("context", context);
stimulus.load(definitionsFromContext(context));

/* STIMULUS */
// boost pay anything form
import "jquery-ui/ui/widgets/slider";
import "ion-rangeslider";

// import(/* webpackChunkName: 'jq_puls' */ "jquery-ui/ui/effects/effect-pulsate");
// import(
//   /* webpackChunkName: 'jq_magpop' */ "magnific-popup/dist/jquery.magnific-popup"
// );
import "lib/snackbar";

//import("lib/jquery_scrollTo");
//require("lib/airplay_jquery_ext");

window._airplay = typeof window._airplay == "undefined" ? {} : window._airplay;

import {
  pop_or_nav,
  // jSimpleBox,
  // jBox,
  // jUploader,
  // jUploader2,
  // show_manage_menu,
  // spinny,
  // refresh_and_show_custom_flyer_box,
  // refresh_and_show_preview,
} from "../../radio_airplay/airplay";

window.pop_or_nav = pop_or_nav;
// window.jSimpleBox = jSimpleBox;
// window.jBox = jBox;
// window.jUploader = jUploader;
// window.jUploader2 = jUploader2;
// window.show_manage_menu = show_manage_menu;
// window.spinny = spinny;
// window.refresh_and_show_custom_flyer_box = refresh_and_show_custom_flyer_box;
// window.refresh_and_show_preview = refresh_and_show_preview;

// import(
//   /* webpackChunkName: 'airplay_autocom' */ "../../radio_airplay/airplay_attach_autocomplete"
// );
// import ListenOverlay from "../../radio_airplay/airplay_listen_overlay";
// window.ListenOverlay = ListenOverlay;
//import PeriodicalExecuter from "lib/periodical_executer";
//window.PeriodicalExecuter = PeriodicalExecuter;

const braintree = require("braintree-web");
window.braintree = braintree;

import Trix from "trix";
window.Trix = Trix;

import Popper from "popper.js";
import "bootstrap5";
//  window.bootstrap = bootstrap;

// import "bootstrap-select";
// $.fn.selectpicker.Constructor.BootstrapVersion = '5';
// import(
//   /* webpackChunkName: 'bs-tggl' */ "bootstrap4-toggle/js/bootstrap4-toggle.min"
// );

import { library, dom, config } from "@fortawesome/fontawesome-svg-core";
config.mutateApproach = "sync";

import {
  faQuestionCircle,
  faExternalLinkSquareAlt,
  faHome,
  faCog,
  faCaretDown,
  faHeadphones,
  faMusic,
  faChartArea,
  faBullseye,
  faPlayCircle,
  faAward,
  faSignOutAlt,
  faSignInAlt,
  //  faEllipsisV,
  faChartLine,
  faTrash,
  faEyeSlash,
  faEye,
  faInfoCircle,
  faArrowCircleLeft,
  faArrowCircleRight,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

import { faFacebookF } from "@fortawesome/free-brands-svg-icons";

// We are only using these icons
library.add(
  faQuestionCircle,
  faExternalLinkSquareAlt,
  faHome,
  faCog,
  faCaretDown,
  faHeadphones,
  faMusic,
  faChartArea,
  faBullseye,
  faPlayCircle,
  faAward,
  faSignOutAlt,
  faSignInAlt,
  //  faEllipsisV,
  faChartLine,
  faTrash,
  faEyeSlash,
  faEye,
  faInfoCircle,
  faFacebookF,
  faArrowCircleLeft,
  faArrowCircleRight,
  faStar,
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();
